import React from "react";
import { Options } from "vis-network";
import { ErrorBoundary } from "react-error-boundary";

import {
  useGetSandboxNetworkData,
  useLocalSampleDetails,
  useLocalSampleSummaryParams
} from "../../samples/hooks";

import RelationshipGraphRS from "./RelationshipGraphRS";
import { RelationshipsGraphEventProvider } from "../context/RelationshipsGraphEventProvider";
import { ThreeDotsLoader } from "../../../components";

const networkOptions = {
  physics: false,
  autoResize: true,
  nodes: {
    brokenImage: "/static/file_types-source-classification/default-unknown.png",
    shapeProperties: {
      interpolation: false // 'true' for intensive zooming
    }
  },
  edges: {
    smooth: false,
    color: "darkgray",
    width: 0.5,
    arrows: {
      to: {
        enabled: true,
        scaleFactor: 0.5
      }
    }
  },
  interaction: {
    dragNodes: false,
    dragView: false,
    zoomView: false,
    selectable: false,
    selectConnectedEdges: false,
    hover: false,
    navigationButtons: false,
    keyboard: false
  }
} as Options;

const GraphErrorComponent = () => (
  <div className="text-center">Error generating Relationship Graph</div>
);
const RelationshipGraphRSContainer = () => {
  const { hash, sourceId, relationshipId, droppedSourceId, parentHash } =
    useLocalSampleSummaryParams();

  const {
    data: sampleDetails,
    isError,
    isLoading
  } = useLocalSampleDetails(
    hash,
    sourceId,
    relationshipId,
    droppedSourceId,
    parentHash
  );
  const { data: sandboxNetworkData, isLoading: isLoadingSandboxNetworkData } =
    useGetSandboxNetworkData(hash ?? "");

  if (isLoading) {
    return <ThreeDotsLoader />;
  }

  if (isError || !sampleDetails) {
    return <GraphErrorComponent />;
  }

  return (
    <ErrorBoundary fallback={<GraphErrorComponent />}>
      <RelationshipsGraphEventProvider>
        <RelationshipGraphRS
          sampleDetails={sampleDetails}
          sandboxNetworkData={sandboxNetworkData}
          isLoadingSandboxNetworkData={isLoadingSandboxNetworkData}
          networkOptions={networkOptions}
        />
      </RelationshipsGraphEventProvider>
    </ErrorBoundary>
  );
};
export default RelationshipGraphRSContainer;
